import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

type Props = {
  designId: string
}

type Data = {
  batch_id: string
}

type Variables = {
  shapeId: string
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const unflattenImage = async (workspaceId: number, designId: string, shapeId: string) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/designs/${designId}/unflatten_image`, {
    method: 'POST',
    body: { shape_id: shapeId },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useUnflattenImage = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((params) => unflattenImage(workspaceId, designId, params.shapeId), options)
}
